document.addEventListener('alpine:init', () => {
  Alpine.data('gbiTikTokRoulette', (config) => ({
    progress: 0,
    activeIndex: 0,
    isMobile: false,
    isVisible: false,
    reduceMotion: false,
    _io: null,
    _resize: null,
    _onScroll: null,
    _sectionUnload: null,
    _rafQueued: false,

    init() {
      const self = this;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.checkMobile();

      this._resize = function () { self.checkMobile(); };
      window.addEventListener('resize', this._resize, { passive: true });

      this._io = new IntersectionObserver(function (entries) {
        if (entries[0]) self.isVisible = entries[0].isIntersecting;
      }, { threshold: 0 });
      this._io.observe(this.$el);

      this._onScroll = function () {
        if (self._rafQueued) return;
        self._rafQueued = true;
        requestAnimationFrame(function () {
          self._rafQueued = false;
          self.updateProgress();
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this.updateProgress();

      this._sectionUnload = function (e) {
        if (self.$el && self.$el.closest('.shopify-section') === e.target) {
          self.destroy();
        }
      };
      document.addEventListener('shopify:section:unload', this._sectionUnload);
    },

    destroy() {
      if (this._io) { this._io.disconnect(); this._io = null; }
      if (this._resize) { window.removeEventListener('resize', this._resize); this._resize = null; }
      if (this._onScroll) { window.removeEventListener('scroll', this._onScroll); this._onScroll = null; }
      if (this._sectionUnload) { document.removeEventListener('shopify:section:unload', this._sectionUnload); this._sectionUnload = null; }
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 968;
    },

    updateProgress() {
      if (this.reduceMotion) {
        this.progress = 0;
        this.activeIndex = 0;
        return;
      }
      const rect = this.$el.getBoundingClientRect();
      const vh = window.innerHeight;
      const total = rect.height - vh;
      if (total <= 0) { this.progress = 0; return; }
      const p = Math.max(0, Math.min(1, -rect.top / total));
      this.progress = p;
      const messages = (config && config.messageCount) || 3;
      this.activeIndex = Math.min(messages - 1, Math.floor(p * messages));
    },

    get showCta() {
      return this.progress > 0.9;
    },

    get fillPercent() {
      return (this.progress * 100).toFixed(2);
    }
  }));
});
